export class CreatePasswordModel {
  constructor(public SecurityCode: string,
              public NewPassword: string,
              public ConfirmPassword: string) {
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/models/create-password/create-password.model.ts